var _g, _g2, _g3, _circle, _rect, _path, _g4, _circle2, _rect2, _path2, _g5, _circle3, _rect3, _path3, _g6, _circle4, _rect4, _path4, _g7, _path5, _circle5, _rect5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmbedCalender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 421 191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#E9EBF0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 66,
    width: 78,
    height: 55,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 127,
    width: 78,
    height: 55,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 66,
    width: 78,
    height: 55,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 127,
    width: 78,
    height: 55,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 5,
    width: 78,
    height: 55,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 78,
    height: 55,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 5,
    width: 78,
    height: 55,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 66,
    width: 78,
    height: 55,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 127,
    width: 78,
    height: 55,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 5,
    width: 78,
    height: 55,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 66,
    width: 78,
    height: 55,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 127,
    width: 78,
    height: 55,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 5,
    width: 77,
    height: 55,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 66,
    width: 77,
    height: 55,
    rx: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    stroke: "#B9BEC7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 12.5,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 12.5,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.5,
    y: 12.5,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.5,
    y: 12.5,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.5,
    y: 12.5,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 73.5,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 73.5,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.5,
    y: 73.5,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.5,
    y: 73.5,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.5,
    y: 73.5,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 134.5,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.5,
    y: 134.5,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.5,
    y: 134.5,
    width: 5,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.5,
    y: 134.5,
    width: 5,
    height: 5,
    rx: 2.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 65,
    width: 80,
    height: 57,
    rx: 3,
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 154,
    cy: 106,
    r: 7.5,
    stroke: "#B9BEC7",
    strokeDasharray: "2 2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 73,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 68a3 3 0 013-3v57a3 3 0 01-3-3V68z",
    fill: "#5595EF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 126,
    width: 80,
    height: 57,
    rx: 3,
    fill: "#fff"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 70,
    cy: 167,
    r: 7.5,
    stroke: "#B9BEC7",
    strokeDasharray: "2 2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 134,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 129a3 3 0 013-3v57a3 3 0 01-3-3v-51z",
    fill: "#E43A25"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 126,
    width: 80,
    height: 57,
    rx: 3,
    fill: "#fff"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 238,
    cy: 167,
    r: 7.5,
    stroke: "#B9BEC7",
    strokeDasharray: "2 2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 134,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174 129a3 3 0 013-3v57a3 3 0 01-3-3v-51z",
    fill: "#7DC560"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 65,
    width: 80,
    height: 57,
    rx: 3,
    fill: "#fff"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 322,
    cy: 106,
    r: 7.5,
    stroke: "#B9BEC7",
    strokeDasharray: "2 2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 269,
    y: 73,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M258 68a3 3 0 013-3v57a3 3 0 01-3-3V68z",
    fill: "#FBCC43"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 4,
    width: 80,
    height: 57,
    rx: 3,
    fill: "#fff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174 7a3 3 0 013-3v57a3 3 0 01-3-3V7z",
    fill: "#B9BEC7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 238,
    cy: 45,
    r: 7.5,
    stroke: "#B9BEC7",
    strokeDasharray: "2 2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 12,
    width: 28,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 84,
    y: 61,
    width: 92,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 0,
    y: 122,
    width: 92,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 168,
    y: 122,
    width: 92,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 252,
    y: 61,
    width: 92,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 168,
    y: 0,
    width: 92,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbedCalender);
export default __webpack_public_path__ + "static/media/embed-calender.025fe36a.svg";
export { ForwardRef as ReactComponent };